'use client';

import { FC, ReactNode } from 'react';
import useFontSize from '@/hooks/useFontSize';

interface IAppWrapperProps {
  children: ReactNode;
}

const AppWrapper: FC<IAppWrapperProps> = ({children}) => {
  const { fontSize } = useFontSize(); 

  return (
    <>
      <style>{`:root {font-size: ${fontSize}px}`}</style>
      {children}
    </>
  )
}

export default AppWrapper;